import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { memo } from "react";
import { BoardSelectBoardListItem } from "~/components/BoardSelect/BoardSelectBoardListItem";
import { BoardSelectListItem } from "~/components/BoardSelect/components/BoardSelectListItem";
import { useLibraryRootBoards } from "~/components/LibraryBeta/hooks/queries/useLibraryRootBoards";
import { useFetchObjectsPermissions } from "~/hooks/useFetchObjectsPermissions";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
export const BoardSelectLibraryListItem = /*#__PURE__*/ memo((param)=>{
    let { canSelect, isBoardDisabled, isBoardExpanded, isBoardSelected, getBoardDisabledMessage, getLibraryDisabledMessage, isLibraryDisabled, isLibraryExpanded, isLibrarySelected, library, onBoardOpenChange, onLibraryOpenChange, onSelectBoard, onSelectLibrary, search, shouldShowSubBoards } = param;
    var _library_color;
    const isExpanded = isLibraryExpanded === null || isLibraryExpanded === void 0 ? void 0 : isLibraryExpanded(library);
    const isDisabled = isLibraryDisabled === null || isLibraryDisabled === void 0 ? void 0 : isLibraryDisabled(library);
    const isSelected = isLibrarySelected === null || isLibrarySelected === void 0 ? void 0 : isLibrarySelected(library);
    const { currentWorkspace } = useCurrentWorkspace();
    const { data: boards = [], isLoadingMore, hasMore, loadNextPage } = useLibraryRootBoards(currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id, library.id, {
        search
    });
    useFetchObjectsPermissions({
        objects: {
            boardIds: boards.map((board)=>board.id)
        }
    });
    var _library_icon;
    return /*#__PURE__*/ _jsxs(BoardSelectListItem, {
        disabled: isDisabled,
        disabledMessage: getLibraryDisabledMessage === null || getLibraryDisabledMessage === void 0 ? void 0 : getLibraryDisabledMessage(library),
        id: library.id,
        isExpanded: isExpanded,
        isSelected: canSelect ? isSelected : false,
        onOpenChange: (isOpen)=>onLibraryOpenChange({
                id: library.id,
                isOpen
            }),
        onSelect: ()=>canSelect ? onSelectLibrary === null || onSelectLibrary === void 0 ? void 0 : onSelectLibrary(isSelected ? undefined : library) : onLibraryOpenChange({
                id: library.id,
                isOpen: !isExpanded
            }),
        prefix: /*#__PURE__*/ _jsx("div", {
            className: "flex size-6 items-center justify-center rounded bg-pigeon-50",
            style: {
                backgroundColor: (_library_color = library.color) === null || _library_color === void 0 ? void 0 : _library_color.backgroundHex
            },
            children: (_library_icon = library.icon) !== null && _library_icon !== void 0 ? _library_icon : "\uD83D\uDCDA"
        }),
        title: library.title,
        children: [
            boards.map((board)=>{
                return /*#__PURE__*/ _jsx(BoardSelectBoardListItem, {
                    board: board,
                    getBoardDisabledMessage: getBoardDisabledMessage,
                    isBoardDisabled: isBoardDisabled,
                    isBoardExpanded: isBoardExpanded,
                    isBoardSelected: isBoardSelected,
                    onBoardOpenChange: onBoardOpenChange,
                    onSelectBoard: onSelectBoard,
                    shouldShowSubBoards: shouldShowSubBoards,
                    search: search
                }, board.id);
            }),
            !isLoadingMore && hasMore && /*#__PURE__*/ _jsx(Button, {
                onClick: ()=>loadNextPage(),
                size: "small",
                appearance: "ghost",
                color: "grey",
                children: "Show more"
            })
        ]
    });
});
BoardSelectLibraryListItem.displayName = "BoardSelectLibraryListItem";
